module.exports = __webpack_public_path__ + "img/shop-feature9.ea3baf66.png";